/*eslint no-magic-numbers: 0*/
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

// actions
import { setNavigationAssets } from "../../../../store/actions/navigation.action";
import {
  fetchMoraleIndicatorComments,
  fetchQuestionAverages,
} from "../../../../store/actions/reports.action";

import PageLoading from "../../../../components/PageLoading";
import IndexScore from "../../components/IndexScore";
import NoSubscription from "../../components/NoSubscription";
import ReportsFooter from "../../components/ReportsFooter";
import ReportsTabbar from "../../components/ReportsTabbar";
import MoraleIndexScore from "./components/MoraleIndexScore/MoraleIndexScore";

import DiscussParagraph from "../../../../components/DiscussParagraph";
import PageContent from "../../../../components/PageContent";
import "./Morale.scss";

class Morale extends Component {
  componentDidMount() {
    const navigation = {
      title: "METRIC REPORTS",
      subtitle: "MORALE INDEX",
      tab: "YOUR REPORTS",
    };
    this.props.setNavigationAssets(navigation);
    this.props.fetchMoraleIndicatorComments();
    if (!this.props.questionAverages) {
      this.props.fetchQuestionAverages();
    }
  }

  render() {
    const { isFullReport, isLoadingPage } = this.props;
    return (
      <PageLoading
        isLoading={isLoadingPage}
        render={() => (
          <Fragment>
            <IndexScore questionAveragesType={"mi"} />
            <PageContent>
              <ReportsTabbar />
              {isFullReport ? (
                <MoraleIndexScore />
              ) : (
                <NoSubscription reportType="Morale Indicator" />
              )}
              <ReportsFooter />
              <DiscussParagraph />
            </PageContent>
          </Fragment>
        )}
      />
    );
  }
}

Morale.propTypes = {
  setNavigationAssets: PropTypes.func,
  fetchMoraleIndicatorComments: PropTypes.func,
  fetchCategoryAverages: PropTypes.func,
  fetchQuestionAverages: PropTypes.func,
  questionAverages: PropTypes.object,
  isLoadingPage: PropTypes.bool,
  isFullReport: PropTypes.bool,
};

const mapStateToProps = ({ reports }) => {
  const isLoadingPage = reports.isLoadingReports || reports.isLoadingComments;

  return {
    isLoadingPage,
    questionAverages: reports.questionAverages,
    isFullReport:
      reports && reports.reportStatus && reports.reportStatus.is_full_report,
  };
};

export default connect(mapStateToProps, {
  setNavigationAssets,
  fetchMoraleIndicatorComments,
  fetchQuestionAverages,
})(Morale);
